import { extendDecorator } from '@/js/common/Domain/Service/mixins/decorators';

@extendDecorator({
    defaults: {
        tourCriteria: null,
        minPrice: null,
    },
})
export default class HistoryItem extends Backbone.Model {}
